<template>
  <div class="contract-list">
	<div class="info-box">
		<div class="info-title">
			回款信息：
		</div>
		<div class="info-list">
			<div>银行流水号：{{hkData.bankSerialNumber}}</div> <div>回款金额：{{hkData.returnMoney}}</div> <div>回款日期：{{hkData.returnTime}}</div> <div>付款方：{{hkData.payer}}</div>
			<div>认领状态：<span v-if="hkData.status==1">未认领</span><span v-else-if="hkData.status==2">部分认领</span><span v-else-if="hkData.status==3">完全认领</span></div> <div>待认领金额：{{hkData.waitClaimMoney}}</div> <div>已认领金额：{{hkData.claimMoney}}  <el-link style="margin-left: 60px;" type="primary" @click="openrlList()" :underline="false">认领记录</el-link></div>
		</div>
		<div style="margin-top: 10px;">备注：{{hkData.remark}}</div>
		<div class="info-title">
			回款认领：
		</div>
		<el-form  ref="InvoiceForm" :rules="rules" label-width="110px" style="margin-top: 20px;">
		  <el-form-item label="认领商务合同:" prop="selectName" class="block-form-item w-32">
		    <el-input v-model="selectName" >
				<i slot="append" @click="selectHt()" class="iconfont icon-xialaxuanze_xialaduoxuan"></i>
			</el-input>
		  </el-form-item>
		  <el-form-item label="认领回款金额:" prop="claimMoney" class="block-form-item w-32">
		    <el-input v-model="claimMoney" maxlength="11" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
		  </el-form-item>
		</el-form>
		<div class="info-title">
			剩余待回款金额：<span>{{dynamicTags[0]?dynamicTags[0].waitReturnMoney:'--'}}</span>
		</div>
		<el-button type="primary" size="medium" @click="submit" style="width: 100px; display: block; margin: 0 auto;">提交</el-button>
	</div>
<!-- 认领商务合同 -->
	<el-dialog title="认领商务合同" :visible.sync="htVisible" width="50%" v-loading="approveLoading">
		<!-- 选中标签 -->
		<div class="select-list">
			<span style="font-size: 15px;line-height: 25px;margin-right: 10px;">已选中合同:</span>
			<el-tag
			  :key="tag.name"
			  v-for="tag in dynamicTags"
			  closable
			  :disable-transitions="false"
			  @close="handleClose(tag)">
			  {{tag.name||''}}
			</el-tag>
		</div>

		<el-row class="filter-wrap" :gutter="20">
		  <el-col :span="8">
			<el-input v-model="swhtForm.nameOrCode" size="small" placeholder="商务合同编号/名称" @keyup.enter.native="onSearch"></el-input>
		  </el-col>
		  <el-col :span="5">
			<el-input v-model="swhtForm.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
		  </el-col>
		  <el-col :span="5">
			<el-input v-model="swhtForm.businessPrincipal" size="small" placeholder="业务负责人" @keyup.enter.native="onSearch"></el-input>
		  </el-col>
		  <el-col :span="4">
			<el-button type="primary" size="small" @click="onSearch">搜索</el-button>
		  </el-col>
		</el-row>
		<div class="table-wrap">
		  <el-table v-loading="tableLoading" :data="tableData" size="small" @selection-change="handleSelectionChange" ref="tb">
			<el-table-column label="选择" type="selection" width="55" :selectable="checkSelect"></el-table-column>
			<el-table-column label="商务合同名称" prop="name" align="center"></el-table-column>
			<el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
			<el-table-column label="业务负责人" prop="businessPrincipal" align="center"></el-table-column>
			<el-table-column label="回款状态" prop="returnStatus" align="center">
				  <template slot-scope="scope">
						<span v-if="scope.row.returnStatus==1">未回款</span>
						<span v-else-if="scope.row.returnStatus==2">部分回款</span>
						<span v-else-if="scope.row.returnStatus==3">全部回款</span>
				  </template>
			</el-table-column>
			<el-table-column label="待回款金额" prop="waitReturnMoney" align="center"></el-table-column>
		  </el-table>

		  <!-- 分页 -->
		  <div class="pagination-wrap">
			<el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="swhtForm.pageNum" :page-sizes="[5]" :page-size="swhtForm.pageSize"
			  layout="sizes, prev, pager, next, jumper" :total="swhtForm.total">
			</el-pagination>
		  </div>
		  <!-- 分页 -->
		  <el-button type="primary" size="medium" @click="submitSwht" style="width: 100px; display: block; margin: 0 auto;margin-top: 10px;">确定</el-button>
		</div>
	</el-dialog>
    <!-- 回款详情 -->
    <el-dialog title="回款详情" :visible.sync="Invoicedialog">
      <el-form :model="InvoiceForm" ref="InvoiceForm" :rules="rules" label-width="110px">
        <el-form-item label="银行流水号:" prop="customerName" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerName" disabled></el-input>
        </el-form-item>
        <el-form-item label="回款金额:" prop="companyPhone" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.companyPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="回款日期:" prop="companyAddress" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.companyAddress" disabled></el-input>
        </el-form-item>
        <el-form-item label="收款类型:" prop="taxpayerId" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.taxpayerId" disabled></el-input>
        </el-form-item>
        <el-form-item label="收款账户:" prop="customerBank" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerBank" disabled></el-input>
        </el-form-item>
        <el-form-item label="收款账户开户行:" prop="customerBankAccount" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerBankAccount" disabled></el-input>
        </el-form-item>
        <el-form-item label="收款账号:" prop="invoiceMoney" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.invoiceMoney"></el-input>
        </el-form-item>
        <el-form-item label="认领状态:" prop="invoiceType" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.invoiceType" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceType')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable" 
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="待认领金额:" prop="customerBank" class="block-form-item w-32">
		  <el-input v-model="InvoiceForm.customerBank" disabled></el-input>
		</el-form-item>
		<el-form-item label="录入人:" prop="customerBank" class="block-form-item w-32">
		  <el-input v-model="InvoiceForm.customerBank" disabled></el-input>
		</el-form-item>
		<el-form-item label="录入时间:" prop="customerBank" class="block-form-item w-32">
		  <el-input v-model="InvoiceForm.customerBank" disabled></el-input>
		</el-form-item>
		<el-form-item label="收款凭证:" prop="customerBank" class="block-form-item w-32">
		  <el-input v-model="InvoiceForm.customerBank" disabled></el-input>
		</el-form-item>
        <el-form-item label="待认领金额:" prop="invoiceDetail" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.invoiceDetail" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceDetail')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable"
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
		<el-form-item label="收款凭证:" prop="invoiceDetail" class="block-form-item">
			<el-upload
			  class="upload-demo"
			  action="https://jsonplaceholder.typicode.com/posts/"
			  :on-preview="handlePreview"
			  :on-remove="handleRemove"
			  :before-remove="beforeRemove"
			  multiple
			  :limit="1"
			  :on-exceed="handleExceed"
			  :file-list="fileList">
			  <el-button size="small" type="primary">点击上传</el-button>
			</el-upload>
		</el-form-item>
        <el-form-item label="备注:" prop="remark" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="InvoiceForm.remark"></el-input>
        </el-form-item>
        <div class="mar-c">
          <el-button type="primary" size="small" @click="onSubmit" :disabled="submitLoading">提交</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 作废详情 -->
    <el-dialog title="作废详情" :visible.sync="invoiceVisible" width="50%">
	  <el-form :model="zfData" ref="zfData" :rules="rules" label-width="110px">
		  <div style="display: flex;justify-content: space-between;">
			  <el-form-item label="作废人:" prop="reasonUserName" class="" style="width: 45%;">
			      <el-input v-model="zfData.reasonUserName" disabled></el-input>
			    </el-form-item>
			    <el-form-item label="作废时间:" prop="reasonTime" class="block-form-item " style="width: 45%;">
			      <el-input v-model="zfData.reasonTime" disabled></el-input>
			    </el-form-item>
		  </div>
		  <el-form-item label="作废原因:" prop="companyAddress" class="block-form-item w-16">
		     <el-input type="textarea" maxlength="500" rows="4" v-model="zfData.reason" disabled=""></el-input>
		  </el-form-item>
<!-- 		  <div class="mar-c">
		    <el-button type="primary" size="small" @click="invoiceVisible=false" :disabled="submitLoading">确定</el-button>
		  </div> -->
	  </el-form>
    </el-dialog>
    <!-- 认领记录 -->
    <el-dialog title="认领记录" :visible.sync="approveVisible" width="80%" v-loading="approveLoading">
		  <template>
		    <el-table
		      :data="rlData"
		      style="width: 100%">
		      <el-table-column prop="contractName" label="认领商务合同名称"  width="180"></el-table-column>
			  <el-table-column prop="claimMoney" label="认领回款金额"  width="180"></el-table-column>
			  <el-table-column prop="createUserName" label="认领操作人"  width="180"></el-table-column>
			  <el-table-column prop="createTime" label="认领操作时间"  width="180"></el-table-column>
			  <el-table-column prop="claimStatus" label="状态"  width="180">
				  <template slot-scope="scope">
						<span v-if="scope.row.claimStatus==0">已认领</span>
						<span v-else-if="scope.row.claimStatus==1">已作废</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="操作" align="center">
			    <template slot-scope="scope">
			      <el-button type="text" size="small" v-if="scope.row.claimStatus!=1" @click="zfClick(scope.id)">作废</el-button>
			  	  <el-button v-if="scope.row.claimStatus!=0" type="text" size="small" @click='zfInfo(scope.row.id)'>作废详情</el-button>
			    </template>
			  </el-table-column>
		    </el-table>
		  </template>
		  <!-- 分页 -->
		  <div class="pagination-wrap">
		    <el-pagination background @size-change="rlSizeChange" @current-change="rlCurrentChange" :current-page.sync="rlpage.pageNum" :page-sizes="[5,10, 20, 30, 40, 50, 100]" :page-size="rlpage.pageSize"
		      layout="sizes, prev, pager, next, jumper" :total="rlpage.total">
		    </el-pagination>
		  </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import validate from "@/util/validate";
import util from "@/util/util";
import { contractConfig } from "@/const/config/contract";
import InvoiceFormFields from "@/const/form/InvoiceForm";
import { billingConfig,billingShow } from "@/const/config/billing";
import {
	hkList,hkInfo,rlList,zfInfoApi,swhtList,subHk,
} from "@/api/business/back";
import { processList } from "@/api/approve/contract";
import approveList from "@/components/common/approveMember";
export default {
  components: {

  },
  data() {
    // 开票金额判断
    var validPrice = (rule, value, callback) => {
      let money = this.remainingMoney;
      if (!validate.checkNull(value)) {
        let err = validate.checkAmount(value, money);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    return {
    billingShow,
	  id:'',//回款id
	  rlData:[],//认领记录
	  zfData:{},//作废信息
	  hkData:{},//回款信息
	  fileList: [],//凭证
	  dynamicTags: [],//选中合同
      billingConfig,
	  htVisible:false,//认领合同
      approveVisible: false,
      approveLoading: false,
	  Invoicedialog: false, //回款详情
	  approveTitle:false,
	  invoiceVisible: false,//作废详情
	  zftxVisible:false,//作废提醒
	  // 商务合同模块
	  swhtForm:{
		  businessPrincipal:'',//业务负责人
		  customerName:'',//客户名称
		  nameOrCode:'',//合同名称/编号
		  pageNum:1,
		  pageSize:5,
		  total:0,
	  },
	  selectName:'',//选中商务合同名称
	  claimMoney:'',//回款金额
      /**
       * 开票提醒模块
       */
      isUploadFile: false, //是否上传
      hasCorrectIncome: false, //KOL收入+有花果收入=净收入
      hasRemainingMoney: false, //剩余金额大于可开票金额


      contractConfig: contractConfig,
      form: {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
        statusList: "",
      },
      InvoiceForm: {
        contractId: null, //合同ID
        customerName: "", //名称
        companyPhone: "", //电话
        companyAddress: "", //公司地址
        taxpayerId: "", //纳税人识别号
        customerBank: "", //客户开户行
        customerBankAccount: "", //客户银行账户
        invoiceMoney: "", //开票金额
        invoiceType: "", //发票类型
        invoiceDetail: "", //开票明细
        remark: "", //合同备注
      },
      rules: {
        claimMoney: [
          { required: true, message: "请输入认领回款金额", trigger: "buir" },
        ],
		selectName:[
		  { required: true, message: "请输入认领商务合同", trigger: "buir" },
		],
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
	  rlpage:{
	  		  pageNum: 1,
	  		  pageSize: 5,
	  		  total: 0,
	  },//认领列表分页
      submitLoading: false,
      tableData: [],
      tableLoading: false,
      /**
       * 业务负责人模块
       */
      adminListModal: false,
      adminPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      adminForm: {
        queryString: "",
      },
      selectAdminId: null,
      selectAdmin: null,
      adminTable: [],
      adminTableLoading: false,
      pid: null,
    };
  },
  mounted() {
	  this.id = this.$route.query.id
	console.log('我是子组件的',this.$route.query.id)
	this.getHkinfo();
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
	  //判断金额是否可选中
	   checkSelect (row,index) {
	        let isChecked = true;
	        if (row.waitReturnMoney != 0) { // 判断金额是否为0
	          isChecked = true
	        } else {
	           isChecked = false
	        }
	      return isChecked
	      },
	  //提交回款认领
	  submit(){
		  if(this.selectName == ''){
			  this.$message.error('请先选择合同');
			  return
		  }
		  if(this.claimMoney == ''){
		  		this.$message.error('请填写回款金额');
		  		return
		  }
			let form = {
				returnMoneyId:Number(this.id) ,
				contractId:this.dynamicTags[0].id,
				claimMoney: Number(this.claimMoney),
			}
			subHk(form)
			  .then((res) => {
					this.getHkinfo();
					if(res.code==1){
					  this.$message({
							  message: '回款认领成功',
							  type: 'success'
							});
					}
			  })
			  .catch((err) => {
						
			  });
	  },
	  //选中商务合同
	  submitSwht(){
		if(this.dynamicTags.length==0){
			this.$message.warning('请先选择商务合同');
			return
		}
		this.htVisible = false
		this.selectName = this.dynamicTags.length!=0?this.dynamicTags[0].name:''
	  },
	  //查看回款详情
	  getHkinfo(){
		  hkInfo(this.id)
		    .then((res) => {
		  			this.hkData  = res.data
					console.log('我是详情',this.hkData)
		    })
		    .catch((err) => {
		  			
		    });
	  },
	  //单选合同
      handleSelectionChange(selection) {
	  console.log(selection)
	  // this.$refs.tb.clearSelection();
	  //         this.$refs.tb.toggleRowSelection(selection.pop());
		  if(selection.length == 1){
			 this.dynamicTags = []
			 this.dynamicTags.push(selection[0]) 
		  }

        if (selection.length > 1) {
          this.$refs.tb.clearSelection();
          this.$refs.tb.toggleRowSelection(selection.pop());
        }
		
		// console.log('选中名字',selection[0].name)
      },
	  //删除选中标签
		handleClose(tag) {
			this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		},
	  // 选择合同
	  selectHt(){
		  this.dynamicTags = [];
		 this.htVisible = true 
		 this.getList();
	  },
	  //跳转认领
	  goel(id){
		  let router = this.$router.resolve({
		    path: "/business/backMoney/edit",
		    query: {
		      id: id,
		    },
		  });
		  window.open(router.href, "_blank");
	  },
	// 查看详情
	lookInfo(id){
	  this.Invoicedialog = true
	},
	//打开认领记录
	openrlList(){
			this.approveVisible = true
			this.getRl();
	},
	// 获取认领记录
	getRl(){
		let obj = {
			id:this.id,
			pageNum:this.rlpage.pageNum,
			pageSize:this.rlpage.pageSize,
		}
		rlList(obj)
		  .then((res) => {
				console.log('我是认领记录',res)
				this.rlData = res.data
				this.rlpage.total = res.total;
				console.log('我是认领记录总数',this.rlpage.total)
		  })
		  .catch((err) => {
					
		  });
	},
	//点击作废
	zfClick(){
		this.$alert('请联系财务操作作废', '作废提醒', {
		  confirmButtonText: '确定',
		  callback: action => {
			
		  }
		});
	},
	//作废信息
	zfInfo(id){
		this.invoiceVisible = true
		zfInfoApi(id)
		  .then((res) => {
				console.log('我是作废信息',res)
				this.zfData = res.data
		  })
		  .catch((err) => {
					
		  });
	},
	// 上传凭证
	  handleRemove(file, fileList) {
		console.log(file, fileList);
	  },
	  handlePreview(file) {
		console.log(file);
	  },
	  handleExceed(files, fileList) {
		this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
	  },
	  beforeRemove(file, fileList) {
		return this.$confirm(`确定移除 ${ file.name }？`);
	  },
    /**重新提交 */
    reSubmit(contractId) {
      this.$confirm("确认重新提交启动审批?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reapply({ contractId }).then((res) => {
            this.$message.success("重新提交成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 业务负责人模块
     */
    //打开资源选择弹窗
    onOpenAdminSelectModal(username, id, pid) {
      if (username) {
        this.selectAdmin = {
          username,
          id,
        };
      } else {
        this.selectAdmin = null;
      }
      this.pid = pid;
      this.adminListModal = true;
    },
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.adminForm.queryString = "";
      this.selectAdminId = null;
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      if (this.selectAdmin) {
        let obj = {
          businessPrincipalId: this.selectAdmin.id,
          contractId: this.pid,
        };
        editAdmin(obj)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("分配成功！");
              this.getList();
            }
          })
          .catch((err) => {});
        this.adminListModal = false;
      } else {
        this.$message.error("不能删除业务负责人！");
      }
    },
    /**认领列表
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    rlSizeChange(val) {
      this.rlpage.pageNum = 1;
      this.rlpage.pageSize = val;
      this.getRl();
    },
    /**认领列表
     * 监听页数变化
     * @param val 当前页数
     */
    rlCurrentChange(val) {
		console.log('我是分页数量',val)
      this.rlpage.pageNum = val;
      this.getRl();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
      };
      if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
        obj.usernameOrPhone = this.adminForm.queryString.trim();
      }
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      console.log(this.selectAdminId);
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
    },

    //提交
    onSubmit() {
      this.$refs.InvoiceForm.validate((valid, obj) => {
        if (valid) {
          let f = util.deepClone(this.InvoiceForm);
          InvoiceAdd(f).then((res) => {
            if (res.code == 1) {
              this.$message.success("申请成功！");
              this.Invoicedialog = false;
              this.getList();
            }
          });
        } else {
          let a = Object.keys(obj).map((v) => {
            let text = "";
            if (!InvoiceFormFields.list[v] && v.lastIndexOf(".") !== -1) {
              let fieldInArray = v.substring(v.lastIndexOf(".") + 1, v.length);
              text = InvoiceFormFields.list[fieldInArray];
            } else {
              text = InvoiceFormFields.list[v];
            }
            return text;
          });
          this.$message.error(
            "表单不完整！请检查" + a.join("、") + "是否按要求填写"
          );
        }
      });
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.swhtForm.pageNum = 1;
      this.swhtForm.pageSize = val;
	  console.log('当前页数',this.swhtForm.pageNum)
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.swhtForm.pageNum = val;
	  console.log('当前页数',this.swhtForm.pageNum)
      this.getList();
    },

    // 搜索
    onSearch() {
      // if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
      //   if (
      //     parseInt(this.form.contractMoneyMin) >
      //     parseInt(this.form.contractMoneyMax)
      //   ) {
      //     this.$message.error("最小合同金额不能大于最大合同金额");
      //     return;
      //   }
      // }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      // console.log("queryObj", queryObj);
      this.tableLoading = true;
	  swhtList(this.swhtForm)
		.then((res) => {
				this.tableLoading = false;
				this.tableData  = res.data
				this.swhtForm.total = res.total;
				console.log('商务合同列表',this.tableData)
		})
		.catch((err) => {
				
		});
    },

    /**
     * 跳转到编辑页
     */
    toEdit(id) {
      let router = this.$router.resolve({
        path: "/business/contract/edit",
        query: {
          id: id,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    Invoicedialog(val) {
      if (!val) {
        this.InvoiceForm = {
          contractId: null, //合同ID
          customerName: "", //名称
          companyPhone: "", //电话
          companyAddress: "", //公司地址
          taxpayerId: "", //纳税人识别号
          customerBank: "", //客户开户行
          customerBankAccount: "", //客户银行账户
          invoiceMoney: "", //开票金额
          invoiceType: "", //发票类型
          invoiceDetail: "", //开票明细
          remark: "", //合同备注
        };
        this.$refs.InvoiceForm.clearValidate("invoiceMoney");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
	.el-input-group__append {
	  position: relative;
	  width: 28px;
	  height: 28px;
	  border: none;
	  background: #fff;
	  padding: 0;
	  color: #409eff !important;
	  .iconfont {
		position: absolute;
		top: 0;
		left: 0;
		  right: 0;
		  bottom: 0;
		  margin: auto;
		font-size: 28px !important;
		   color: #409eff !important;
		   margin: 0 auto !important;
		   text-align: center !important;
	  }
	  cursor: pointer;
	}
// 选中合同
.select-list{
	display: flex;
	justify-content: start;
	margin-bottom: 10px;
}
// 回款信息
.info-title{
	margin-top: 10px;
	font-weight: bold;
}
.info-list{
	display: flex;
	justify-content: start;
	flex-wrap: wrap;
}
.info-list div{
	width:25%;
	margin-top: 10px;
}
	
	
	
.table-wrap{
	margin-top: 20px;
}
.mar-c {
  display: flex;
  justify-content: center;
}
.table-count {
  margin: 15px 0 10px;
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      left: -1px;
      font-size: 33px !important;
    }
    cursor: pointer;
  }
}
.select-con {
  .el-tag .el-icon-close {
    top: -8px;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}
</style>
<!-- 选中标签 -->
<style>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>